import { useUpdateEffect } from 'ahooks'
import { Input, Select, Space } from 'antd'
import { isNil } from 'lodash'

import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { CertificationInputProps } from './interface'

const options = [
  {
    label: '无',
    value: false
  },
  {
    label: '有',
    value: true
  }
]

const Component = ({
  disabled,
  value = {},
  onChange
}: CertificationInputProps) => {
  // 当没有额外资质要求时清空已输入的额外资质
  useUpdateEffect(() => {
    if (!value.requireCertification && !isNil(value.certificationName)) {
      onChange?.({ ...value, certificationName: undefined })
    }
  }, [value.requireCertification])

  const handleSelectChange = (requireCertification: boolean) => {
    onChange?.({
      ...value,
      requireCertification
    })
  }

  const handleInputChange = (certificationName: string) => {
    onChange?.({
      ...value,
      certificationName
    })
  }

  return (
    <Space.Compact>
      <Select
        allowClear={false}
        disabled={disabled}
        options={options}
        style={{ width: 120 }}
        value={value.requireCertification}
        onChange={handleSelectChange}
      />
      <Input
        disabled={disabled || !value.requireCertification}
        value={value.certificationName}
        onChange={e => handleInputChange(e.target.value)}
      />
    </Space.Compact>
  )
}

export const CertificationInput = connect(
  Component,
  mapReadPretty(Component, {
    disabled: true
  })
)
